import { Injectable } from '@angular/core';
import { OpenApiRemoteMethod, RxapOpenApiRemoteMethod } from 'eurogard-open-api-remote-method';
import { StatusControllerSmsStatusResponse } from '../responses/status-controller-sms-status.response';

@Injectable({
    providedIn: 'root'
  })
@RxapOpenApiRemoteMethod({
    serverId: 'legacy',
    operationId: 'status-controller-smsStatus',
    operation: '{"operationId":"status-controller-smsStatus","responses":{"200":{"content":{"application/json":{"schema":{"type":"object","additionalProperties":{"type":"string"}}}}}},"method":"get","path":"/status-controller/sms-status"}'
  })
export class StatusControllerSmsStatusRemoteMethod extends OpenApiRemoteMethod<StatusControllerSmsStatusResponse, void, void> {
  public override call(): Promise<StatusControllerSmsStatusResponse> {
    return super.call();
  }
}
